import React from 'react';
import MajorBox from './MajorBox';
import styles from './MajorBoxGroup.module.scss';
const MajorBoxGroup = ({ degreeData, setDeletState }) => {
  let filteredData;
  if (Array.isArray(degreeData)) {
    filteredData = degreeData?.sort((a, b) => a.degreeType - b.degreeType);
  }
  return (
    <div className={styles['major-box-grid']}>
      {' '}
      {filteredData?.map((program) => (
        <div key={program.degreeId}>
          <MajorBox
            key={program.degreeId}
            program={program}
            setDeletState={setDeletState}
          />
        </div>
      ))}
    </div>
  );
};

export default MajorBoxGroup;
